import { render } from "./ordentrabajo.vue?vue&type=template&id=20c7f0f5"
import script from "./ordentrabajo.vue?vue&type=script&lang=js"
export * from "./ordentrabajo.vue?vue&type=script&lang=js"

import "./ordentrabajo.vue?vue&type=style&index=0&id=20c7f0f5&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__